import script from "./interest.vue?vue&type=script&setup=true&lang=js"
export * from "./interest.vue?vue&type=script&setup=true&lang=js"

import "./interest.vue?vue&type=style&index=0&id=dc8d7ff0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc8d7ff0"]])

export default __exports__